<template>
  <ui-dialog :show="isOpen" @input="close">
    <template #header>
      <h3>
        {{
          $t("message.companyProfile.listings.importSummary.locationsImport")
        }}
      </h3>
    </template>
    <template #default>
      <div>
        <p v-if="summaryData && summaryData.success">
          {{
            $t(
              "message.companyProfile.listings.importSummary.dialogMessages.successfullyImported",
              {
                success_count: summaryData.success
              }
            )
          }}
        </p>
        <p v-if="summaryData && summaryData.imported">
          {{
            $t(
              "message.companyProfile.listings.importSummary.dialogMessages.importing",
              {
                importing_count: summaryData.imported
              }
            )
          }}
        </p>
        <p v-if="summaryData && summaryData.error">
          {{
            $t(
              "message.companyProfile.listings.importSummary.dialogMessages.error",
              {
                error_count: summaryData.error
              }
            )
          }}
        </p>
        <p v-if="summaryData && summaryData.alreadyImported">
          {{
            $t(
              "message.companyProfile.listings.importSummary.dialogMessages.alreadyImported",
              {
                already_imported_count: summaryData.alreadyImported
              }
            )
          }}
        </p>
        <p v-if="summaryData && summaryData.unverified">
          {{
            $t(
              "message.companyProfile.listings.importSummary.dialogMessages.unverified"
            )
          }}
          {{ summaryData.unverified }}
        </p>
      </div>
    </template>
    <template #actions>
      <div class="d-flex justify-end w-100">
        <ui-button color="primary" outlined @click="close">
          {{ $t("message.common.ok") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "ImportSummaryDialog",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    summaryData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
